import { render, staticRenderFns } from "./MetricRow.ts.vue?vue&type=template&id=32f29bd8"
import script from "./MetricRow.ts.vue?vue&type=script&lang=ts"
export * from "./MetricRow.ts.vue?vue&type=script&lang=ts"
import style0 from "./MetricRow.ts.vue?vue&type=style&index=0&id=32f29bd8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports